export default __webpack_public_path__ + "static/media/rid-02@2x.fec568c2.jpg";